<template>
  <EmptyLayout>
    <div class="h-full flex items-center justify-center">
      <MessageBox :title="$t('common.label.development')" :icon="'tetrisly/code-2'" />
    </div>
    <SCADivider appearance="border" />
    <div class="px-component-padding-6xLarge">
      <!-- <FileExplorer
        folder-id="sdkjfnsdjkfh"
        record-id="asdasjdgashjdgjhasdgjhsa"
        class="mb-component-padding-2xLarge"
      /> -->
    </div>
  </EmptyLayout>
</template>

<script lang="ts" setup>
import { SCADivider } from "@scayla/components";

// import FileExplorer from "@/components/fileExplorer/FileExplorer.vue";
import MessageBox from "@/components/MessageBox.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
</script>

<style module lang="scss"></style>
